export const newHeader = {
  "Como você está se sentindo?": "Como você está se sentindo?",
  "Enviar": "Enviar",
  "Se sentindo muito feliz 😆": "Se sentindo muito feliz 😆",
  "Se sentindo feliz 🙂": "Se sentindo feliz 🙂",
  "Se sentindo neutro 😐": "Se sentindo neutro 😐",
  "Se sentindo triste 🙁": "Se sentindo triste 🙁",
  "Se sentindo muito triste 😓": "Se sentindo muito triste 😓",
  "Sentimento enviado.": "Sentimento enviado.",
  "Nos conte porque você está se sentindo assim...": "Nos conte porque você está se sentindo assim...",
};



// WEBPACK FOOTER //
// ./src/resources/ptBR/newHeader.js